import { urlAPI, urlAPIv2 } from "../../../urls";

// api/config.ts
export const urlLegacy = urlAPI;  
export const urlV2     =  urlAPIv2 ;


export type ApiMode = 'legacy' | 'agentLoader';


export const apiMode: ApiMode = "agentLoader"
//  process.env.REACT_APP_IS_DEV  !== 'true' ? 'agentLoader' : 'legacy';



export const endpoints = {
    agentLoader: {
        users:        '/bso/agent-loader/users',
        currentUser:  '/bso/agent-loader/current-user',
        units:        '/bso/agent-loader/units',
        documents:    '/bso/agent-loader/documents',
        viewings:     '/bso/agent-loader/viewings',
        offers:       '/bso/agent-loader/offers',
        advertises:   '/bso/agent-loader/advertises',
        chats:        '/bso/agent-loader/chats',        
        properties :  '/bso/agent-loader/properties',
        unitsPublic:  '/bso/agent-loader/units-public'
    },
    main : {
       uploadFile : '/bso/file-upload'
    },
    adminRequests : {
        users:        '/bso/admin/get-users',
        currentUser:  '/bso/admin/get-current-user',
        units:        '/bso/admin/get-units',
        documents:    '/bso/admin/get-documents',
        viewings:     '/bso/admin/get-viewings',
        keyViewings:  '/bso/admin/get-key-viewings',
        keyViewingReceptionHistory: (viewingId: number) => `/bso/admin/key-viewings/${viewingId}/reception-history`,
        offers:       '/bso/admin/get-offers',
        advertises:   '/bso/admin/get-advertises',
        chats:       '/bso/admin/get-chats' ,        
        properties :   '/bso/admin/get-properties',
        unitsPublic:  '/bso/agent-loader/units-public'
    }


} as const;
